import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { Typography, Box, Paper, Divider } from '@material-ui/core';
import Filter from '../../../components/Dashboard/Filter/Point-Date';
import MaterialTable from 'material-table';
import { tableIcons } from '../../../configs/ui/TableConfig';
import Axios from 'axios';
import { useSnackbar } from 'notistack';
import {
   graph_mock,
   multitable_mock,
} from '../../../mockdata/dashboard/mock-graph-7';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import EmptyChart from '../../../components/Dashboard/Chart/EmptyChart';
import DownloadPDFButton from '../../../components/Dashboard/Button/DownloadPDF';
import { useLocation } from 'react-router-dom';
import FileSaver from 'file-saver';
import DownloadExcelButton from '../../../components/Dashboard/Button/DownloadExcel';
import moment from 'moment';

let mock = false;
let GRAPH_COLORS = ['#EC068D75', '#D633FF75']; // these colors need to be set in database instead

const useStyles = makeStyles((theme) => ({
   loading: {
      height: '434px',
      width: '100%',
      backgroundColor: '#F2F2F2',
      borderRadius: '5px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
   },
   graphsContainer: {
      width: '100%',
      display: 'flex',
   },
   tablesContainer: {
      backgroundColor: 'white',
      height: '100%',
   },
}));

const PointAndRedeem = () => {
   const classes = useStyles();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [MultiChartData, setMultiChartData] = useState([]);
   const [MultiTable, setMultiTable] = useState(null);
   const [isLoadingExcel, setIsLoadingExcel] = useState(false);
   const [isLoadingMultiTable, setIsLoadingMultiTable] = useState(false);
   const [isLoadingGraph, setIsLoadingGraph] = useState(false);
   const [filtersData, setFiltersData] = useState();
   const location = useLocation();
   const getChartsOptionsDefault = () => {
      let option = {
         tooltip: {
            trigger: 'axis',
            axisPointer: {
               // Use axis to trigger tooltip
               type: 'shadow', // 'shadow' as default; can also be 'line' or 'shadow'
            },
         },
         grid: {
            top: '3%',
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true,
         },
         xAxis: {
            type: 'value',
         },
         yAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            axisLabel: {
               formatter: function (value) {
                  let maxlength = 20;
                  return value.length > maxlength
                     ? value.substring(0, maxlength - 1) + '...'
                     : value;
               },
            },
         },
         series: [
            {
               label: {
                  show: true,
                  position: 'right',
               },
               type: 'bar',
               data: [50, 302, 301, 334, 390, 330, 350],
            },
         ],
      };
      return option;
   };
   const onFiltersSubmit = (filters) => {
      setFiltersData(filters);
      var params = new URLSearchParams();
      filters.pointType.map((el) => params.append('pointType', el));
      params.append('startDate', filters.startDateString);
      params.append('endDate', filters.endDateString);
      if (mock) {
         setIsLoadingGraph(true);
         setTimeout(() => {
            setIsLoadingGraph(false);
            setMultiChartData(graph_mock.graphs);
         }, 1000);
      } else {
         setIsLoadingGraph(true);
         Axios.get('/GSB/dashboard/dashboard/GetTopActivityGraph', {
            params: params,
         })
            .then((resp) => {
               let colors = GRAPH_COLORS;
               let mapped = resp.data.graphs.map((el, i) => ({
                  ...el,
                  color: colors[i],
               }));
               setMultiChartData(mapped);
               // enqueueSnackbar('ดึงข้อมูลกราฟสำเร็จ', { variant: 'success' });
            })
            .catch((e) => {
               setMultiChartData(null);
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(response.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else console.error('site error');
            })
            .finally(() => {
               setIsLoadingGraph(false);
            });
      }
   };
   const mapOptions = (data) => {
      const getColor = (pointType) => {
         switch (pointType) {
            case 'G':
               return '#F383BB';
            case 'S':
               return '#623C21';
            case 'B':
               return '#EDD217';
         }
      };
      let yAxisLabels = data.activities.map((el) => el.activityNameTh);
      let Xdata = data.activities.map((el) => ({
         value: el.participateCount,
         itemStyle: {
            color: getColor(el.pointType),
         },
      }));
      let options = getChartsOptionsDefault();
      options.yAxis.data = yAxisLabels;
      options.series[0].data = Xdata;
      return options;
   };
   useEffect(() => {
      getMultiTable();
   }, []);

   const getMultiTable = () => {
      if (mock) {
         setTimeout(() => {
            setMultiTable(multitable_mock.datas);
         }, 100);
      } else {
         setIsLoadingMultiTable(true);
         Axios.get('/GSB/dashboard/dashboard/GetTopDepartmentParticipate')
            .then((resp) => {
               setMultiTable(resp.data.datas);
               // enqueueSnackbar('ดึงข้อมูลตารางสำเร็จ', { variant: 'success' });
            })
            .catch((e) => {
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(e.response.data.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else {
                  console.error('site error');
               }
            })
            .finally(() => {
               setIsLoadingMultiTable(false);
            });
      }
   };

   const handleDownloadExcel = () => {
      setIsLoadingExcel(true);
      Axios.get(`/GSB/dashboard/dashboard/GetTopDepartmentParticipate`, {
         responseType: 'blob',
         params: {
            isGenerateReport: true,
         },
      })
         .then((response) => {
            setIsLoadingExcel(false);
            FileSaver.saveAs(
               new Blob([response.data]),
               'แสดงจำนวนผู้เข้าร่วมกิจกรรม Top 10.xlsx',
            );
         })
         .catch((err) => {
            enqueueSnackbar('เกิดข้อผิดพลาด กรุณาตรวจสอบข้อมูล', {
               variant: 'error',
            });
         });
   };

   return (
      <div>
         <Box margin={'10px 0px'} textAlign={'end'}>
            <DownloadPDFButton
               disabled={isLoadingGraph || isLoadingMultiTable}
               to={() => {
                  localStorage.setItem(
                     'report',
                     JSON.stringify({
                        filtersData,
                        MultiChartData,
                        MultiTable,
                     }),
                  );
                  return {
                     pathname: location.pathname + '/report',
                  };
               }}
            />
         </Box>
         <Paper>
            <Box padding={'10px'} marginBottom={'10px'}>
               <Typography variant='h5'>
                  แสดงจำนวนผู้เข้าร่วมกิจกรรม Top 10
               </Typography>
               <Filter
                  isLoading={isLoadingGraph}
                  onSubmit={onFiltersSubmit}
                  defaultSubmitFirstParams
                  startDate={new Date(moment().subtract(2, 'years'))}
                  endDate={new Date()}
               />
            </Box>
            <Box padding={'10px'}>
               {MultiChartData ? (
                  <Box className={classes.graphsContainer}>
                     {MultiChartData &&
                        MultiChartData.map((item, index) => (
                           <Box key={index} width={'50%'}>
                              <Box fontSize={24} fontWeight={'bold'}>
                                 {item.graphName}
                              </Box>
                              <ReactECharts
                                 option={mapOptions(item)}
                                 style={{ height: 300, width: '100%' }}
                              />
                           </Box>
                        ))}
                  </Box>
               ) : (
                  <EmptyChart
                     text={'ไม่มีข้อมูล, โปรดระบุตัวกรองด้านบนเพื่อแสดงกราฟ'}
                     show={true}
                     height={300}
                  />
               )}
            </Box>
            <Divider variant='middle' />
            <Box marginTop={'10px'} padding={'10px'}>
               <Box textAlign={'end'}>
                  <DownloadExcelButton
                     isLoading={isLoadingExcel}
                     onClick={handleDownloadExcel}
                  />
               </Box>
               <Box display={'flex'}>
                  {isLoadingMultiTable ? (
                     <div className={classes.loading}>
                        <CircularProgress size={20} />
                     </div>
                  ) : (
                     MultiTable &&
                     MultiTable.map((item, index) => (
                        <Box
                           className={classes.tablesContainer}
                           key={index}
                           marginRight={
                              index !== MultiTable.length - 1 ? '10px' : 0
                           }
                           width={'50%'}
                        >
                           <Box
                              minHeight={100}
                              fontSize={20}
                              fontWeight={'bold'}
                              display={'flex'}
                              justifyContent={'center'}
                              textAlign={'center'}
                              alignItems={'center'}
                           >
                              {item.listName}
                           </Box>
                           <MaterialTable
                              columns={[
                                 {
                                    field: 'seq',
                                    title: 'ลำดับ',
                                    sorting: false,
                                    width: 10,
                                 },
                                 {
                                    field: 'name',
                                    title: 'ชื่อสังกัด',
                                    sorting: false,
                                 },
                                 {
                                    field: 'participateCount',
                                    title: 'จำนวน',
                                    sorting: false,
                                 },
                              ]}
                              data={item.departmentParticipate}
                              options={{
                                 paging: false,
                                 showTitle: false,
                                 headerStyle: {
                                    fontWeight: 'bold',
                                    backgroundColor: '#F6F6F6',
                                 },
                                 actionsColumnIndex: -1,
                                 addRowPosition: 'first',
                                 actionsCellStyle: {
                                    color: '#ccc',
                                 },
                                 padding: 'dense',
                                 pageSize: 10,
                                 search: false,
                                 toolbar: false,
                                 draggable: false,
                              }}
                              localization={{
                                 body: {
                                    editRow: {
                                       deleteText:
                                          'ต้องการลบข้อมูลนี้ใช่หรือไม่?',
                                    },
                                 },
                                 header: { actions: 'ตัวจัดการ' },
                              }}
                              icons={tableIcons}
                           />
                        </Box>
                     ))
                  )}
               </Box>
            </Box>
         </Paper>
      </div>
   );
};

export default PointAndRedeem;
